import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, UserCog } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

const F = ({ label, children }) => (
  <label className="block space-y-1">
    <span className="text-[10px] font-mono uppercase tracking-wider text-slate-400">{label}</span>
    {children}
  </label>
);

export default function AccountDialog({ email }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ email: "", current: "", password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF({ email: email || "", current: "", password: "", confirm: "" }); }, [open, email]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.password && f.password !== f.confirm) return toast.error("New passwords don't match");
    setBusy(true);
    try {
      await api.put("/admin/account", { current_password: f.current, email: f.email !== email ? f.email : null, password: f.password || null });
      toast.success("Login details updated — use them next time you sign in");
      setTimeout(() => window.location.reload(), 900);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className="flex items-center gap-1.5 text-xs text-slate-300 hover:text-white px-3 py-1.5 rounded-md border border-slate-800 hover:border-slate-600 transition-colors" data-testid="superadmin-account-button">
          <UserCog size={14} /> My login
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-md bg-slate-900 border-slate-800" data-testid="superadmin-account-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">Super admin login</DialogTitle>
          <DialogDescription>Change your login email and/or password. Your current password is required.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <F label="Login email (ID)"><input type="email" required className="cf-input h-9 text-sm" value={f.email} onChange={set("email")} data-testid="account-email-input" /></F>
          <div className="grid grid-cols-2 gap-3">
            <F label="New password"><input type="password" minLength={6} className="cf-input h-9 text-sm" placeholder="Leave empty to keep" value={f.password} onChange={set("password")} data-testid="account-new-password-input" /></F>
            <F label="Confirm new password"><input type="password" className="cf-input h-9 text-sm" value={f.confirm} onChange={set("confirm")} data-testid="account-confirm-password-input" /></F>
          </div>
          <F label="Current password"><input type="password" required className="cf-input h-9 text-sm" value={f.current} onChange={set("current")} data-testid="account-current-password-input" /></F>
          <button disabled={busy} className="cf-btn-primary w-full h-10" data-testid="account-save-button">{busy && <Loader2 size={14} className="animate-spin" />} Save login details</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
